// ¿Se montan las rutas /dev/* (harnesses de diseño y previews del shell)?
//
// Hasta el 15-sep-2026 estaban siempre montadas, también en clubsagent.ai:
// /dev/socios-shell pintaba el shell completo con un UserContext de superadmin
// sin ninguna sesión. Sin token no salían datos, pero cualquiera veía la app
// «por dentro» (menú de superadmin incluido) sin loguearse.
//
// Regla: en el servidor de desarrollo siempre; en un build de producción solo
// si el build lo pide con REACT_APP_DEV_ROUTES=1 (lo hace el e2e de CI para
// seguir barriendo esas páginas). Dokploy y prod no lo ponen → apagadas.
//
// Recibe el env como argumento para poder testearlo: CRA inyecta process.env.*
// en tiempo de build y Jest corre con NODE_ENV=test.
export function devRoutesEnabled(env = process.env) {
  if (env.NODE_ENV !== "production") return true;
  return env.REACT_APP_DEV_ROUTES === "1";
}

export const DEV_ROUTES_ENABLED = devRoutesEnabled();
